import { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive/js/dataTables.responsive.min.js";

function ProductionRequestTable({ requests, onView, onEdit, onDelete }) {
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);

  useEffect(() => {
    if (!requests || requests.length === 0) return;

    const $table = $(tableRef.current);

    // Destroy existing DataTable before re-initializing
    if (dataTableRef.current) {
      dataTableRef.current.destroy();
      $table.empty();
      dataTableRef.current = null;
    }

    dataTableRef.current = $table.DataTable({
      destroy: true,
      responsive: true,
      colReorder: true,
      data: requests,
      columns: [
        {
          data: null,
          render: (data, type, row, meta) => meta.row + 1,
          title: "#"
        },
        {
          data: 'requestNumber',
          title: "Request No.",
          render: (data, type, row) => {
            let html = `<div>${data}</div>`;
            if (row.requestType === 'SALES_ORDER' && row.salesOrders?.length > 0) {
              html += `<small class="text-muted">
                ${row.salesOrders.length} Sales Order${row.salesOrders.length > 1 ? 's' : ''}
              </small>`;
            }
            return html;
          }
        },
        {
          data: 'productId.productName',
          title: "Product",
          defaultContent: "N/A"
        },
        {
          data: 'quantityRequired',
          title: "Quantity",
          render: (data, type, row) => `${data} ${row.productId?.unitId?.unitCode || ""}`
        },
        {
          data: 'status',
          title: "Status",
          render: (data, type, row) => {
            let badgeClass = data === "COMPLETED" ? "success" : data === "IN_PROGRESS" ? "warning" : "secondary";
            let html = `<div class="d-flex flex-column gap-1">
              <span class="badge text-bg-${badgeClass}">${data}</span>`;
            
            if (row.stockValidationSummary?.lowStockCount > 0) {
              html += `<span class="badge text-bg-danger">${row.stockValidationSummary.lowStockCount} Low Stock</span>`;
            }
            html += `</div>`;
            return html;
          }
        },
        {
          data: 'bomId.bomId',
          title: "BOM",
          defaultContent: "—"
        },
        {
          data: 'requiredDate',
          title: "Required Date",
          render: (data) => data ? new Date(data).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }) : "—"
        },
        {
          data: '_id',
          title: "Actions",
          className: 'text-end',
          orderable: false,
          render: (data, type, row) => {
            let html = `<div class="d-flex gap-2 justify-content-end">
              <a href="/production-requests/${data}" class="btn btn-sm btn-outline-info">
                <i class="fas fa-eye"></i>
              </a>`;
            
            if (row.status === "PENDING") {
              html += `<button class="btn btn-sm btn-outline-danger delete-btn" data-id="${data}">
                <i class="fas fa-trash"></i>
              </button>`;
            }
            html += `</div>`;
            return html;
          }
        }
      ],
      layout: {
        bottomEnd: {
          paging: { firstLast: false },
        },
      }
    });

    $(tableRef.current).on('click', '.delete-btn', function() {
      const id = $(this).data('id');
      const req = requests.find(r => r._id === id);
      if (req) onDelete(req);
    });

    return () => {
      if (dataTableRef.current) {
        dataTableRef.current.destroy();
        dataTableRef.current = null;
      }
      if (tableRef.current) {
        $(tableRef.current).off('click', '.delete-btn');
      }
    };
  }, [requests, onDelete]);

  if (!requests || requests.length === 0) {
    return <p>No production requests found.</p>;
  }

  return (
    <div className="table-responsive">
      <table
        ref={tableRef}
        className="table table-bordered table-hover table-sm display responsive nowrap"
        id="productionRequestsTable"
        style={{ width: '100%' }}
      >
      </table>
    </div>
  );
}

export default ProductionRequestTable;
